import { useEffect, useState } from 'react';
import { patientPortal } from '@/api/patientPortal';
import PatientPortalPageHero from './PatientPortalPageHero';

type Challenge = {
  id: string;
  title: string;
  description: string | null;
  targetCount: number;
  pointsReward: number;
  badgeLabel: string | null;
  myProgress: number;
  completedAt: string | null;
};

export default function PatientPortalChallenges() {
  const [challenges, setChallenges] = useState<Challenge[]>([]);

  useEffect(() => {
    patientPortal.getChallenges().then(setChallenges);
  }, []);

  return (
    <div className="space-y-6">
      <PatientPortalPageHero
        imageKey="challenges"
        eyebrow="Wellness"
        title="Health challenges"
        subtitle="Complete goals, stay active, and earn bonus loyalty points"
        compact
      />
      <p className="text-muted-foreground">Complete challenges to earn bonus points and badges.</p>
      <div className="grid gap-4">
        {challenges.map((c) => (
          <div key={c.id} className="border rounded-xl p-5 bg-white">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-semibold">{c.title}</h3>
                {c.description && <p className="text-sm text-muted-foreground mt-1">{c.description}</p>}
              </div>
              {c.completedAt ? (
                <span className="text-xs bg-teal-100 text-teal-800 px-2 py-1 rounded">
                  {c.badgeLabel || 'Done'}
                </span>
              ) : null}
            </div>
            <div className="mt-4">
              <div className="h-2 bg-slate-100 rounded overflow-hidden">
                <div
                  className="h-full bg-teal-600 transition-all"
                  style={{ width: `${Math.min(100, (c.myProgress / c.targetCount) * 100)}%` }}
                />
              </div>
              <p className="text-xs text-muted-foreground mt-1">
                {c.myProgress} / {c.targetCount} — reward {c.pointsReward} pts
              </p>
            </div>
          </div>
        ))}
        {challenges.length === 0 && <p className="text-muted-foreground">No active challenges.</p>}
      </div>
    </div>
  );
}
